export default function TextValue({ label, value }) {
  return (
    <div>
      <div className="text-sm font-medium text-gray-700 mb-1">{label}</div>
      <div className="text-gray-900 text-sm">
        {value || <span className="text-gray-400 italic text-sm">未填写</span>}
      </div>
    </div>
  )
}
